import React, { useRef, useState } from 'react';
import { BodyRegular, BodySmall, BodyVerySmall } from '../atoms/fonts/Body';
import { useSelector } from "react-redux";
import { selectCurrentUser } from '@shared/store/auth.duck';
import styled from "styled-components";
import IconButton from "./icon-button/IconButton";
import Colours from "../atoms/Colours";
import { IconTypes } from "../atoms/icon/Icon";
import { useTranslation } from "react-i18next";
import { smallTablet } from "../atoms/MediaQueries";
import { UserAvatarInfoHoverBox } from "../organisms/user-avatar-info-hover-box/UserAvatarInfoHoverBox";
import { BasicUserInfo } from '@shared/models/user.models';
import { Row } from "../atoms/StructuralLayout";

export function CurrentUserAvatarAndName(props: OptionalProps) {
  const current = useSelector(selectCurrentUser);
  return <>
    <UserAvatarAndName firstName={current?.firstname || ''} lastName={current?.lastname || ''} {...props} />
  </>
}

export function UserAvatarAndName({userId = '', isAdmin = false, colour = 'none',
                                    className = '', onClick = () => {}, fullName = undefined,
                                    hideName = false, showEditLink = false, onHoverIcon = undefined,
                                    firstName = '', lastName = '', mouseOver = () => {}, mouseLeave = () => {},
                                    jobTitle = undefined, email = undefined, disableHover = false, showHolidayContentOnHover = false,
                                    basicUserInfo = undefined, showUserHoverInfo = false, style = {}}: Props) {
  const name = fullName || (firstName + ' ' + lastName);
  const initials = !!firstName && !!lastName ? firstName[0] + lastName[0] : '';
  const colourClass = `userAvatarAndName__avatar--${colour}`;
  const textColourClass = `userAvatarAndName--${colour}`;
  const showEditLinkClass = (showEditLink || onHoverIcon) ? `userAvatarAndName__editLink--hover` : '';
  const {t} = useTranslation();
  const [hoverVisible, setHoverVisible] = useState(false);
  const [hoverPos, setHoverPos] = useState({ x: 0, y: 0 });
  const containerRef = useRef<HTMLDivElement | null>(null);

  const onMouseOver = () => {
    if (disableHover) {
      return;
    }
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setHoverPos({ x: rect.left + 80, y: rect.top + 30 });
    }
    setHoverVisible(true);
    mouseOver();
  }

  const onMouseLeave = () => {
    if (disableHover) {
      return;
    }

    setHoverVisible(false);
    mouseLeave();
  }

  return (
    <Wrapper
      style={style ?? {}}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onTouchStart={onMouseOver}
      onTouchEnd={onMouseLeave}
      onTouchCancel={onMouseLeave}>
      <Container className={`userAvatarAndName ${className} ${showEditLinkClass}`.trim()}
                 ref={containerRef}>
        <Initials className={`userAvatarAndName__avatar ${colourClass}`.trim()}>{initials.toUpperCase()}</Initials>
        {!hideName && <>

          {!!email ? <>
            <Column>
              <Row className={'userAvatarAndName__name--jobTitle'} style={{marginTop: 14, alignItems: 'center'}}>
                <BodyRegular title={name}>{name}</BodyRegular>
                {jobTitle && <BodyVerySmall style={{marginLeft: 6}} colour={Colours.darkGrey} title={jobTitle}>({jobTitle})</BodyVerySmall>}
              </Row>
              <BodyVerySmall colour={Colours.darkGrey} title={jobTitle} className={`userAvatarAndName__jobTitle ${textColourClass}`.trim()}>{email}</BodyVerySmall>
            </Column>
          </> : <>
            <Column>
              <BodyRegular className={!!jobTitle ? 'userAvatarAndName__name--jobTitle' : 'userAvatarAndName__jobTitle'} style={{marginTop: !!jobTitle ? 14 : 0}} title={name}>{name}</BodyRegular>
              {jobTitle && <BodyVerySmall colour={Colours.darkGrey} title={jobTitle} className={`userAvatarAndName__jobTitle ${textColourClass}`.trim()}>{jobTitle}</BodyVerySmall>}
            </Column>
          </>}

          <BodySmall colour={Colours.darkGrey} style={{marginLeft: 8}} className={`userAvatarAndName__access ${textColourClass}`.trim()} hidden={!isAdmin}>{t('general.admin')}</BodySmall>

          {onHoverIcon && <div className="userAvatarAndName__editLink">
            <IconButton icon={IconTypes.Holiday} />
          </div>}
        </>}

      </Container>
      {hoverVisible && showUserHoverInfo && <UserAvatarInfoHoverBox x={hoverPos.x} y={hoverPos.y}
                                                                    userId={userId}
                                                                    firstName={firstName}
                                                                    lastName={lastName}
                                                                    jobTitle={jobTitle}
                                                                    showHolidayContentOnHover={showHolidayContentOnHover}
                                                                    basicUserInfo={basicUserInfo}
                                                                    initials={initials.toUpperCase()}/>}
    </Wrapper>
  )
}

interface OptionalProps {
  hideName?: boolean;
  className?: string;
  isAdmin?: boolean;
  colour?: 'blue' | 'green' | 'none' | 'darkBlue' | 'grey' | 'lightGrey' | 'transparent' | 'visitor' | 'white';
  onClick?: any;
  mouseOver?: () => any;
  mouseLeave?: () => any;
  jobTitle?: string;
  showUserHoverInfo?: boolean;
}

interface Props extends OptionalProps {
  userId?: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  showEditLink?: boolean;
  disableHover?: boolean;
  onHoverIcon?: IconTypes;
  showHolidayContentOnHover?: boolean;
  basicUserInfo?: BasicUserInfo;
  style?: any;
  email?: string;
}

const Container = styled.div<any>``

export const Initials = styled.p`
  font-family: "soleil", sans-serif;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
`
const Column = styled.div`
  margin-left: 12px;
  max-width: 100%;
  @media (${smallTablet}) {
    max-width: 78%;
  }
`
const Wrapper = styled.div`
  position: relative;
`
